import { ScreenBase } from "@frui.ts/screens";
import type { Notification } from "services/notificationService";

export enum AlertVariant {
  SUCCESS = "success",
  DANGER = "danger",
  WARNING = "warning",
  INFO = "info",
}

export default class AlertViewModel extends ScreenBase {
  constructor(public notification: Notification, public variant: AlertVariant, public onClose?: () => void) {
    super();
  }

  get canBeNavigationActiveScreen() {
    return false;
  }
}
